import { render, staticRenderFns } from "./relestoque.vue?vue&type=template&id=07862cae&"
import script from "./relestoque.vue?vue&type=script&lang=js&"
export * from "./relestoque.vue?vue&type=script&lang=js&"
import style0 from "./relestoque.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports